import { useEffect } from "react";
import styled from "styled-components";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import SectionTitle from "components/text/SectionTitle";

import MediaContainer from "./MediaContainer";
import { useNavigate } from "react-router-dom";
import AdPlanOverview from "./AdPlanOverview";
import AdPlanPostSettingsContainer from "./AdPlanPostSettingsContainer";
import SponsoredMessagesContainer from "./SponsoredMessagesContainer";

const AdPlan = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

export default () => {
  const navigate = useNavigate();

  // set page Title
  useEffect(() => {
    document.title = "Advertising Plan | Scalelup";
  }, []);

  const UserProperties = createSelector(
    (state) => state.User,
    (user) => ({
      profileData: user.profileData,
    })
  );

  const { profileData } = useSelector(UserProperties);

  useEffect(() => {
    if (profileData.adPlan === 0) {
      navigate("/advertising-plans");
    }
  }, [profileData]);

  return (
    <Layout>
      <AdPlan>
        <PageTitle>Advertising Plan</PageTitle>
        <AdPlanOverview plan={profileData.adPlan} />
        <SectionTitle>Post Settings</SectionTitle>
        <AdPlanPostSettingsContainer profileData={profileData} />
        <SectionTitle>Media</SectionTitle>
        <MediaContainer plan={profileData.adPlan} />
        <SectionTitle>Sponsored Messages</SectionTitle>
        <SponsoredMessagesContainer profileData={profileData} />
      </AdPlan>
    </Layout>
  );
};
